import React, {
  useState,
  useEffect,
} from "react";

import { useNavigate } from "react-router-dom";

import {
  getLeaves,
  getLeaveBalance,
  getLeaveTransactions,
} from "../../api/api";

// =====================================================
// LEAVE BALANCE PAGE
// =====================================================

export default function LeaveBalance() {

  const navigate =
    useNavigate();

  const [isMobile, setIsMobile] =
    useState(window.innerWidth < 768);

  const [year, setYear] =
    useState("2026");

  const [leaveData, setLeaveData] =
    useState([]);

  const [balanceData, setBalanceData] =
    useState(null);

  const [transactions, setTransactions] =
    useState([]);

  // =====================================================
  // RESPONSIVE
  // =====================================================
  useEffect(() => {

  const handlePopState = () => {

    // If no proper history then redirect home
    if (
      window.history.length <= 1
    ) {

      navigate("/", {
        replace: true,
      });
    }
  };

  window.addEventListener(
    "popstate",
    handlePopState
  );

  return () => {

    window.removeEventListener(
      "popstate",
      handlePopState
    );
  };

}, [navigate]);

  useEffect(() => {

    const handleResize = () =>
      setIsMobile(
        window.innerWidth < 768
      );

    window.addEventListener(
      "resize",
      handleResize
    );

    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );

  }, []);

  // =====================================================
  // INITIAL LOAD
  // =====================================================

  useEffect(() => {

    if (
      localStorage.getItem("user")
    ) {

      fetchLeaveBalance();

      fetchTransactions();
    }

  }, [year]);

  // =====================================================
  // FETCH BALANCE
  // =====================================================

  const fetchLeaveBalance =
    async () => {

      try {

        const balance =
          await getLeaveBalance();

        const leaves =
          await getLeaves();

        setBalanceData(balance);

        const user =
          JSON.parse(
            localStorage.getItem("user")
          ) || {};

        // =================================================
        // FILTER CURRENT YEAR
        // =================================================

        const myLeaves =
          leaves.filter((leave) => {

            const leaveYear =
              new Date(
                leave.from_date
              ).getFullYear();

            return (
              Number(leave.user_id) ===
                Number(user?.id) &&
              leaveYear === Number(year)
            );
          });

        // =================================================
        // APPROVED / PENDING
        // =================================================

        const approvedLeaves =
          myLeaves.filter(
            (leave) =>
              leave.status ===
              "approved"
          );

        const pendingLeaves =
          myLeaves.filter(
            (leave) =>
              leave.status ===
              "pending"
          );

        // =================================================
        // TOTAL LOP
        // =================================================

        // =================================================
// CURRENT PAYROLL CYCLE LOP (26 -> 25)
// =================================================

const today = new Date();

let cycleStart;
let cycleEnd;

if (today.getDate() >= 26) {

  cycleStart = new Date(
    today.getFullYear(),
    today.getMonth(),
    26
  );

  cycleEnd = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    25
  );

} else {

  cycleStart = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    26
  );

  cycleEnd = new Date(
    today.getFullYear(),
    today.getMonth(),
    25
  );
}

const totalLOP =
  approvedLeaves
    .filter((leave) => {

      const fromDate =
        new Date(leave.from_date);

      const toDate =
        new Date(leave.to_date);

      return (
        fromDate <= cycleEnd &&
        toDate >= cycleStart
      );
    })
    .reduce(
      (sum, leave) =>
        sum +
        Number(
          leave.lop_days || 0
        ),
      0
    );

        // =================================================
        // GROUP DATA
        // =================================================

        const result = [

          {
            name:
              "Total Balance",

            granted:
              Number(
                balance?.total_balance ||
                0
              ),

            pending: 0,

            balance:
              Number(
                balance?.total_balance ||
                0
              ),

            active: true,
          },

          {
            name:
              "Planned Leave",

            granted:
              approvedLeaves
                .filter(
                  (leave) =>
                    leave.leave_category ===
                    "planned"
                )
                .reduce(

                  (sum, leave) =>

                    sum +
                    Number(
                      leave.deducted_days ||
                      0
                    ),

                  0
                ),

            pending:
              pendingLeaves
                .filter(
                  (leave) =>
                    leave.leave_category ===
                    "planned"
                )
                .reduce(

                  (sum, leave) =>

                    sum +
                    Number(
                      leave.days || 0
                    ),

                  0
                ),

            balance:
              Number(
                balance?.planned_balance ||
                0
              ),

            active: true,
          },

          {
            name:
              "Emergency Leave",

            granted:
              approvedLeaves
                .filter(
                  (leave) =>
                    leave.leave_category ===
                    "unplanned"
                )
                .reduce(

                  (sum, leave) =>

                    sum +
                    Number(
                      leave.deducted_days ||
                      0
                    ),

                  0
                ),

            pending:
              pendingLeaves
                .filter(
                  (leave) =>
                    leave.leave_category ===
                    "unplanned"
                )
                .reduce(

                  (sum, leave) =>

                    sum +
                    Number(
                      leave.days || 0
                    ),

                  0
                ),

            balance:
              Number(
                balance?.unplanned_balance ||
                0
              ),

            active: true,
          },

          {
  name:
    "Loss Of Pay",

  used:
    totalLOP,

  pending: 0,

  description:
    "Salary deduction applicable",

  active: false,
},
        ];

        setLeaveData(result);

      } catch (error) {

        console.error(error);
      }
    };

  // =====================================================
  // FETCH TRANSACTIONS
  // =====================================================

  const fetchTransactions =
    async () => {

      try {

        const data =
          await getLeaveTransactions();

        setTransactions(
          data || []
        );

      } catch (error) {

        console.error(error);
      }
    };

    // =====================================================
// AUTO REFRESH
// =====================================================

useEffect(() => {

  const refreshData = () => {

    fetchLeaveBalance();

    fetchTransactions();
  };

  window.addEventListener(
    "leave-updated",
    refreshData
  );

  return () => {

    window.removeEventListener(
      "leave-updated",
      refreshData
    );
  };

}, []);

  // =====================================================
  // UI
  // =====================================================

  return (

    <div style={styles.container}>

      {/* ================================================= */}
      {/* HEADER */}
      {/* ================================================= */}

      <div style={styles.headerRow}>

        <h2 style={styles.title}>
          Leave Details
        </h2>

        <div style={styles.actions}>

          <button
            style={styles.applyBtn}

            onClick={() =>
              navigate(
                "/leave/apply"
              )
            }
          >
            Apply Leave
          </button>

          <select
            value={year}

            onChange={(e) =>
              setYear(
                e.target.value
              )
            }

            style={styles.yearSelect}
          >

            <option>
              2026
            </option>

            <option>
              2025
            </option>

            <option>
              2024
            </option>

          </select>

        </div>

      </div>

      {/* ================================================= */}
      {/* SUMMARY */}
      {/* ================================================= */}

      {/* {balanceData && (

        <div style={styles.summaryWrapper}>

          <div style={styles.summaryCard}>

            <div style={styles.summaryLabel}>
              Total Balance
            </div>

            <div style={styles.summaryValue}>
              {
                Number(
                  balanceData.total_balance ||
                  0
                ).toFixed(1)
              }
            </div>

          </div>

          <div style={styles.summaryCard}>

            <div style={styles.summaryLabel}>
              Planned Leave
            </div>

            <div style={styles.summaryValue}>
              {
                Number(
                  balanceData.planned_balance ||
                  0
                ).toFixed(1)
              }
            </div>

          </div>

          <div style={styles.summaryCard}>

            <div style={styles.summaryLabel}>
              Emergency Leave
            </div>

            <div style={styles.summaryValue}>
              {
                Number(
                  balanceData.unplanned_balance ||
                  0
                ).toFixed(1)
              }
            </div>

          </div>

        </div>
      )} */}

      {/* ================================================= */}
      {/* LEAVE GRID */}
      {/* ================================================= */}

      <div style={styles.grid}>

        {leaveData.map(
          (leave, index) => (

            <LeaveCard
              key={index}
              data={leave}
            />
          )
        )}

      </div>

      {/* ================================================= */}
      {/* TRANSACTIONS */}
      {/* ================================================= */}

      <div style={styles.transactionWrapper}>

        <h3 style={styles.transactionTitle}>
          Recent Transactions
        </h3>

        {transactions.length ===
        0 ? (

          <div style={styles.emptyState}>
            No transactions found
          </div>

        ) : (

          transactions.map(
            (transaction) => (

              <div
                key={transaction.id}

                style={
                  styles.transactionCard
                }
              >

                {/* ====================== */}
                {/* LEFT */}
                {/* ====================== */}

                <div
                  style={
                    styles.transactionLeft
                  }
                >

                  <div
                    style={{
                      ...styles.badge,
                      background:
                        getBadgeColor(
                          transaction.transaction_type
                        ),
                    }}
                  >

                    {
                      transaction.transaction_label
                    }

                  </div>

                  <div
                    style={
                      styles.transactionDate
                    }
                  >

                    {
                      new Date(
                        transaction.created_at
                      ).toLocaleDateString()
                    }

                  </div>

                  <div
                    style={
                      styles.transactionRemark
                    }
                  >

                    {
                      transaction.split_summary ||
                      transaction.remarks
                    }

                  </div>

                </div>

                {/* ====================== */}
                {/* RIGHT */}
                {/* ====================== */}

                <div
                  style={
                    styles.transactionRight
                  }
                >

                  <div
                    style={
                      styles.transactionDays
                    }
                  >

                    {
                      Number(
                        transaction.days || 0
                      ).toFixed(1)
                    }

                  </div>

                  {(transaction.deducted_days >
                    0 ||
                    transaction.lop_days >
                      0) && (

                    <div
                      style={
                        styles.transactionBreakup
                      }
                    >

                      {transaction.deducted_days >
                        0 && (

                        <div>
                          Deducted:
                          {" "}
                          {
                            Number(
                              transaction.deducted_days
                            ).toFixed(1)
                          }
                        </div>
                      )}

                      {transaction.lop_days >
                        0 && (

                        <div>
                          LOP:
                          {" "}
                          {
                            Number(
                              transaction.lop_days
                            ).toFixed(1)
                          }
                        </div>
                      )}

                    </div>
                  )}

                </div>

              </div>
            )
          )
        )}

      </div>

    </div>
  );
}

// =====================================================
// LEAVE CARD
// =====================================================

function LeaveCard({
  data,
}) {

  return (

    <div style={styles.card}>

      {/* ================================================= */}
      {/* TOP */}
      {/* ================================================= */}

      <div style={styles.cardHeader}>

        <span style={styles.leaveName}>
          {data.name}
        </span>

        <div>

          <div style={styles.granted}>

            {
              data.active
                ? (
                    <>
                      Used:
                      {" "}
                      {
                        Number(
                          data.granted || 0
                        ).toFixed(1)
                      }
                    </>
                  )
                : (
                    <>
                      This Month:
                      {" "}
                      {
                        Number(
                          data.used || 0
                        ).toFixed(1)
                      }
                    </>
                  )
            }

          </div>

          <div style={styles.pending}>

            {
              data.active
                ? (
                    <>
                      Pending:
                      {" "}
                      {
                        Number(
                          data.pending || 0
                        ).toFixed(1)
                      }
                    </>
                  )
                : (
                    data.description
                  )
            }

          </div>

        </div>

      </div>

      {/* ================================================= */}
      {/* CENTER */}
      {/* ================================================= */}

      <div style={styles.cardCenter}>

        <div style={styles.balanceNumber}>

          {
            data.active
              ? Number(
                  data.balance || 0
                ).toFixed(1)
              : Number(
                  data.used || 0
                ).toFixed(1)
          }

        </div>

        <div style={styles.balanceText}>

          {
            data.active
              ? "Available"
              : "This Month"
          }

        </div>

      </div>

      {/* ================================================= */}
      {/* FOOTER */}
      {/* ================================================= */}

      <div style={styles.cardFooter}>

        <button
          style={{
            ...styles.smallBtn,

            background:
              data.active
                ? "#eff6ff"
                : "#fff7ed",

            color:
              data.active
                ? "#2563eb"
                : "#ea580c",
          }}
        >

          {
            data.active
              ? "Active"
              : "Payroll Impact"
          }

        </button>

      </div>

    </div>
  );
}

// =====================================================
// BADGE COLOR
// =====================================================

function getBadgeColor(type) {

  if (
    type?.includes("rollback")
  ) {
    return "#dbeafe";
  }

  if (
    type?.includes("approved")
  ) {
    return "#fee2e2";
  }

  if (
    type?.includes("credit")
  ) {
    return "#dcfce7";
  }

  return "#f3f4f6";
}

// =====================================================
// STYLES
// =====================================================

const styles = {

  container: {

    background: "#f5f6f8",

    minHeight: "100vh",

    padding:
      window.innerWidth < 768
        ? "14px"
        : "25px",

    fontFamily:
      "'Inter', sans-serif",

    color: "#111",
  },

  headerRow: {

    display: "flex",

    justifyContent:
      "space-between",

    flexDirection:
      window.innerWidth < 768
        ? "column"
        : "row",

    alignItems:
      window.innerWidth < 768
        ? "flex-start"
        : "center",

    gap: "12px",

    marginBottom: "20px",
  },

  title: {

    fontSize:
      window.innerWidth < 768
        ? "20px"
        : "28px",

    fontWeight: "700",

    color: "#111827",
  },

  actions: {

    display: "flex",

    gap: "10px",

    alignItems: "center",

    width:
      window.innerWidth < 768
        ? "100%"
        : "auto",

    flexWrap: "wrap",
  },

  applyBtn: {

    background: "#2563eb",

    border: "none",

    color: "#fff",

    padding:
      window.innerWidth < 768
        ? "10px 14px"
        : "10px 18px",

    borderRadius: "12px",

    cursor: "pointer",

    fontWeight: "600",

    fontSize:
      window.innerWidth < 768
        ? "13px"
        : "14px",

    boxShadow:
      "0 6px 18px rgba(37,99,235,0.18)",
  },

  yearSelect: {

    padding:
      window.innerWidth < 768
        ? "10px 12px"
        : "8px 12px",

    borderRadius: "12px",

    border:
      "1px solid #d1d5db",

    background: "#fff",

    fontSize: "14px",
  },

  summaryWrapper: {

    display: "grid",

    gridTemplateColumns:
      window.innerWidth < 768
        ? "1fr"
        : "repeat(3,1fr)",

    gap: "16px",

    marginBottom: "24px",
  },

  summaryCard: {

    background: "#fff",

    borderRadius: "20px",

    padding: "22px",

    border:
      "1px solid #e5e7eb",

    boxShadow:
      "0 10px 24px rgba(0,0,0,0.05)",
  },

  summaryLabel: {

    fontSize: "14px",

    color: "#6b7280",

    marginBottom: "8px",
  },

  summaryValue: {

    fontSize: "34px",

    fontWeight: "800",

    color: "#111827",
  },

  grid: {

    display: "grid",

    gridTemplateColumns:
      window.innerWidth < 768
        ? "1fr"
        : "repeat(auto-fit,minmax(280px,1fr))",

    gap:
      window.innerWidth < 768
        ? "14px"
        : "20px",

    marginBottom: "30px",
  },

  card: {

    background: "#fff",

    borderRadius:
      window.innerWidth < 768
        ? "18px"
        : "24px",

    border:
      "1px solid #e5e7eb",

    padding:
      window.innerWidth < 768
        ? "16px"
        : "22px",

    minHeight:
      window.innerWidth < 768
        ? "130px"
        : "160px",

    display: "flex",

    flexDirection: "column",

    justifyContent:
      "space-between",

    transition: "0.2s",

    boxShadow:
      "0 10px 30px rgba(15,23,42,0.05)",
  },

  cardHeader: {

    display: "flex",

    justifyContent:
      "space-between",

    alignItems: "flex-start",

    gap: "10px",

    fontSize:
      window.innerWidth < 768
        ? "13px"
        : "14px",

    color: "#444",
  },

  leaveName: {

    fontWeight: "700",

    fontSize:
      window.innerWidth < 768
        ? "15px"
        : "17px",

    color: "#111827",
  },

  granted: {

    fontSize: "13px",

    color: "#777",
  },

  pending: {

    fontSize: "13px",

    color: "#777",
  },

  cardCenter: {

    textAlign: "center",

    marginTop: "10px",
  },

  balanceNumber: {

    fontSize:
      window.innerWidth < 768
        ? "26px"
        : "38px",

    fontWeight: "800",

    color: "#111827",
  },

  balanceText: {

    fontSize:
      window.innerWidth < 768
        ? "12px"
        : "14px",

    color: "#6b7280",

    marginTop: "4px",
  },

  cardFooter: {

    textAlign: "center",
  },

  smallBtn: {

    border: "none",

    padding: "8px 14px",

    borderRadius: "10px",

    cursor: "pointer",

    fontSize: "12px",

    fontWeight: "700",
  },

  transactionWrapper: {

    background: "#ffffff",

    borderRadius: "20px",

    padding: "22px",

    border:
      "1px solid #e5e7eb",

    boxShadow:
      "0 10px 30px rgba(15,23,42,0.05)",
  },

  transactionTitle: {

    fontSize: "20px",

    fontWeight: "700",

    marginBottom: "20px",

    color: "#111827",
  },

  transactionCard: {

    display: "flex",

    justifyContent:
      "space-between",

    gap: "20px",

    alignItems: "flex-start",

    padding: "16px 0",

    borderBottom:
      "1px solid #f1f5f9",
  },

  transactionLeft: {

    flex: 1,
  },

  transactionRight: {

    textAlign: "right",

    minWidth: "120px",
  },

  badge: {

    padding: "6px 12px",

    borderRadius: "999px",

    fontSize: "12px",

    fontWeight: "700",

    display: "inline-block",
  },

  transactionDate: {

    fontSize: "12px",

    color: "#6b7280",

    marginTop: "6px",
  },

  transactionRemark: {

    marginTop: "8px",

    fontSize: "13px",

    color: "#374151",

    lineHeight: "20px",
  },

  transactionDays: {

    fontWeight: "800",

    color: "#2563eb",

    fontSize: "20px",
  },

  transactionBreakup: {

    marginTop: "8px",

    fontSize: "12px",

    color: "#6b7280",

    lineHeight: "18px",
  },

  emptyState: {

    textAlign: "center",

    color: "#6b7280",

    padding: "30px 0",
  },
};